export default __webpack_public_path__ + "static/media/cotton_candy.680d5320.png";